import React, { useEffect } from 'react';
import ReactMarkdown from "react-markdown"
import rehypeRaw from 'rehype-raw';
import $ from "jquery";
import DateFormat from '@components/format-date/';
import { Link, useStaticQuery, graphql } from "gatsby";
import ImgBox from '@components/img-box/img-box';
import { Logo, GoogleReviewIcon } from '@components/icon/icon';
import { Row, Container, Col } from 'react-bootstrap';
import Img from "gatsby-image"; 
import './styles/_index.scss'  
import Intro from '@components/intro/intro';
import Breadcrumbs from '@components/breadcrumbs/breadcrumbs';
import gql from "graphql-tag"
import { useQuery } from '@apollo/client';
import SEO from "@components/seo";
 

function NewsIntro(props) { 

  if (typeof window !== "undefined") {
    $(window).scroll(function () {
      var sticky = $('.sticky-header'),
        scroll = $(window).scrollTop();

      if (scroll >= 40) sticky.addClass('fixed');
      else sticky.removeClass('fixed');
    });
  }

  if (typeof window !== "undefined") {
    $.getJSON('https://www.theestas.com/api/widget?api_token=qayro8ImsRiW2xXhxJoabXNVgLYnOG5flqiJ34WhdLQ7WtXOg1rs1Cos6B8E&with_comments=true&demo=0', function (datas) {
      var text = datas.reviewCount;
      var rating = datas.rating + '%';
      $(".mypanel").html(text);
      $(".myrating").html(rating);
    })
  }

  const datas = useStaticQuery(graphql`
    query {
        reviews: file(relativePath: { eq: "reviews.png" }) {
        childImageSharp {
            fluid(maxWidth: 100, maxHeight: 44, quality: 100) {
                ...GatsbyImageSharpFluid
            }
        }
    }
    }
`);

  return (
    <>
      <Row>
        <Col md={12} xl={8} lg={12}>
          <div className="intro">
            <div className="intro__text">
              <h1>{props?.Title}</h1>
              {props?.Published_Date &&
               <p className='text-20'><DateFormat date={props?.Published_Date} /></p>
              }
             
            </div>
            <div className="intro__reviews">
              <a class="btn null" href="/value-my-property/">Book a valuation today</a>
              <div className="intro__reviews-text">
                <GoogleReviewIcon />
                <p><span className='myrating text-20-16 bold'></span> <span className="d-none d-md-inline">Customer Service Rating</span> from <strong><span className='mypanel'></span> Reviews</strong></p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>

  )
}

export default NewsIntro